import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgDeliveroo = function SvgDeliveroo(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: 35,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M21.39 7.977a.025.025 0 0 0-.028.022l-.873 8.217c-.003.028-.044.03-.05.002l-1.482-6.901a.025.025 0 0 0-.03-.02l-4.744.988a.025.025 0 0 0-.02.03l1.494 7.03a.025.025 0 0 1-.019.03l-6.846 1.437a.025.025 0 0 0-.019.03l1.218 5.606c.002.01.01.017.019.019l12.11 2.555a.025.025 0 0 0 .028-.014l2.767-6.13a.025.025 0 0 0 .002-.008L26.23 8.506a.025.025 0 0 0-.023-.028l-4.818-.501Zm-4.288 12.302a.795.795 0 0 1-.794-.793c0-.438.357-.794.794-.794.437 0 .794.356.794.794a.795.795 0 0 1-.794.793Zm3.175 1.588a.795.795 0 0 1-.794-.794c0-.437.357-.794.794-.794.437 0 .794.357.794.794a.795.795 0 0 1-.794.794Z",
      fill: "currentColor"
    }))
  }));
};
export default SvgDeliveroo;